/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import translations from '@nike/gameday-translations/web';
import IntlMessageFormat from 'intl-messageformat';

export class TranslatedCopy extends Component {
  getDefaultTranslation(id) {
    const { en } = translations;
    return en[id];
  }

  toString() {
    const { id, values, defaultMessage } = this.props;
    const locale = sessionStorage.getItem('locale') || 'en';
    const { [locale]: localizedMessages } = translations;
    const translatedMessage = localizedMessages[id];
    const content = translatedMessage || defaultMessage || this.getDefaultTranslation(id) || `${id}`;
    try {
      return new IntlMessageFormat(content).format(values);
    } catch (e) {
      const contentEN = this.getDefaultTranslation(id);
      console.log(
        `invalid transaltion for key: ${id} and locale: ${locale}, content: ${content}, contentEN: ${contentEN}`,
        this.props
      );
      window.newrelic?.noticeError(e, { handled: true, invalidTranslationKey: id, content, contentEN, locale });
      return new IntlMessageFormat(contentEN).format(values);
    }
  }

  render() {
    const { id, values, defaultMessage: propsDefaultMessage } = this.props;
    if (typeof id === 'string' && id.length > 0 && Object.keys(translations.en).includes(id)) {
      const defaultMessage = propsDefaultMessage || this.getDefaultTranslation(id) || `${id}`;
      const formattedMessageProps = {
        id,
        defaultMessage,
        values
      };
      return <FormattedMessage {...formattedMessageProps} />;
    }
    return id;
  }
}

TranslatedCopy.defaultProps = {
  values: {},
  defaultMessage: null
};

TranslatedCopy.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.object,
  defaultMessage: PropTypes.string
};

export default TranslatedCopy;
